import { render, staticRenderFns } from "./StoreReturningForm.vue?vue&type=template&id=b8def960&"
import script from "./StoreReturningForm.vue?vue&type=script&lang=js&"
export * from "./StoreReturningForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports